module.exports = __webpack_public_path__ + "files/StudyDefinition_and_DataMigrations_Guide.pdf";